module.exports = __webpack_public_path__ + "img/0Q3A7692_L_Wood.1d022f92.jpg";